import {types} from './types'

const initialState ={
    transporter_id:'',
    loading: false,
    transporter_data: '',
    err:'',
} 

const fetchDataReducer = (state = initialState, action) => {
    switch(action.type){
        case types.SEND_REQUEST:
            return {
                ...state,
                loading: true,
            }
        case types.SEND_REQUEST_SUCCESS:
            return {
                ...state,
                loading: false,
                transporter_data: action.payload,
                err: {}
            }
        case types.SEND_REQUEST_FAILURE:
            return {
                ...state,
                loading: false,
                transporter_data: '',
                err: action.payload
            }
        default:
            return state
    }
}

export default fetchDataReducer